import { Box, Typography } from '@gapartners/ui';
import type { CustomerDetailsSectionProps } from './types';

export function CustomerDetailsSection({
  t,
  customerData,
}: CustomerDetailsSectionProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.clientId')}: {customerData.clientId}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.legalName')}: {customerData.legalName}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.company')}: {customerData.companyName}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.serviceLevel')}:{' '}
        {customerData.serviceLevel}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.temperature')}: {customerData.temperature}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.corporationType')}:{' '}
        {customerData.corporationType}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.clientStatus')}:{' '}
        {customerData.clientStatus}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.contractType')}:{' '}
        {customerData.contractType}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.lastInteraction')}:{' '}
        {new Date(customerData.lastInteractionDate).toLocaleDateString()}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('components.contactCenter.totalCases')}: {customerData.totalCases}
      </Typography>
    </Box>
  );
}
